import React, { useEffect, useState } from 'react';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme, Typography } from '@mui/material';

import { useAppSelector, useAppDispatch } from 'hooks';

import { alertsActions } from 'state/alerts';

import ListAlertsPage from 'components/ListAlertsPage';

import AlertOverview from 'components/alerts/Overview';
import AlertListItem from 'components/alerts/ListItem';

import { AlertManager } from 'models';

const useStyles = makeStyles(({ spacing }: Theme) =>
    createStyles({
        text: {
            margin: spacing(2),
        },
    }),
);

interface PageProps {}

const AlertsOverviewPage: React.FunctionComponent<PageProps> = () => {
    const classes = useStyles();
    const dispatch = useAppDispatch();
    const { alerts } = useAppSelector((state) => state);

    const { alertAckResponse } = useAppSelector((root) => root.alerts);

    /*
    useEffect(() => {
        if (alerts.alertDetails.status === 'finished') {
            dispatch(alertsActions.getAlertList());
        }
    }, [alerts.alertAckResponse]);
    */

    const [selectedAlertId, setSelectedAlertId] =
        useState<AlertManager.Alert['id']>();

    const [searchText, setSearchText] = useState('');

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [moreItemsLoading, setMoreItemsLoading] = useState(false);
    const [pageNum, setPageNum] = useState(1);

    const [alertsData, setAlertsData] = useState(alerts.list.object?.results);

    // const selectedAlert =
    //     alertsData && alertsData.find((a) => a.id === selectedAlertId);
    const [selectedAlert, setSelectedAlert] = useState<AlertManager.Alert>();

    const filteredAlerts =
        alertsData &&
        alertsData?.filter((a) => {
            if (!searchText) return true;

            const search = searchText.toUpperCase();

            return (
                a.type.toUpperCase().includes(search) ||
                a.details.includes(search)
            );
        });

    //Add code below for lazy loading on scroll
    const loadMore = () => {
        setPageNum((p) => p + 1);

        setMoreItemsLoading(true);

        dispatch(alertsActions.getNext({ pageNum })).then((results) => {
            if (results.length !== 0) {
                if (alertsData) {
                    // If alertsData is not undefined, append the new items to the existing array
                    setAlertsData([...alertsData, ...results]);
                } else {
                    // If alertsData is undefined, set the state variable to the new items
                    setAlertsData(results);
                }
            } else {
                console.log('No data');
            }
            setMoreItemsLoading(false);
        });
    };

    //Updates selectedAlert, everytime alertAckResponse status changes (i.e. user clicks Acknowledge button)
    useEffect(() => {
        if (selectedAlertId) {
            dispatch(alertsActions.getAlert({ id: selectedAlertId })).then(
                (results) => {
                    setSelectedAlert(results);
                },
            );
        }
    }, [alertAckResponse]);

    //Updates selectedAlert, everytime user clicks an alert in the list.
    useEffect(() => {
        if (selectedAlertId) {
            dispatch(alertsActions.getAlert({ id: selectedAlertId })).then(
                (results) => {
                    setSelectedAlert(results);
                },
            );
        }
    }, [selectedAlertId]);

    return (
        <>
            {filteredAlerts && (
                <ListAlertsPage
                    title="Historical Alerts"
                    breadcrumbs={[
                        { text: 'Home', link: '/' },
                        { text: 'Alert Overview' },
                    ]}
                    onSearchChange={(text) => setSearchText(text)}
                    totalCount={alerts.list.object?.totalCount}
                    list={filteredAlerts.map((a) => (
                        <AlertListItem
                            key={a.id}
                            alert={a}
                            onClick={() => {
                                setSelectedAlertId(a.id);
                            }}
                        />
                    ))}
                    loadMore={loadMore}
                >
                    {selectedAlert && <AlertOverview alert={selectedAlert} />}
                    {!selectedAlert && selectedAlertId == null && (
                        <Typography
                            variant="h6"
                            align="center"
                            className={classes.text}
                        >
                            Select An Alert
                        </Typography>
                    )}
                    {!selectedAlert && selectedAlertId != null && (
                        <Typography
                            variant="h6"
                            align="center"
                            className={classes.text}
                        >
                            Cannot find Alert with Id {selectedAlertId}
                        </Typography>
                    )}
                </ListAlertsPage>
            )}
        </>
    );
};

AlertsOverviewPage.displayName = 'AlertsOverviewPage';
export default AlertsOverviewPage;
